var __webpack_exports__ = {};
/*!************************************************!*\
  !*** ./src/scripts/product-recently-viewed.js ***!
  \************************************************/
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }

  atcEventTracking = () => {
    var selectors = "recently-viewed.product-recommendations button[name='add']";

    if (jQuery351(selectors).length) {
      jQuery351(selectors).each(function (index) {

        var selector = jQuery351(this).data('index');
        jQuery351("recently-viewed.product-recommendations button[data-index='" + selector + "']").on("click",function(event) {
          var elem = jQuery351(this).closest(".grid__item.slider__slide");
          var productName = elem.data("productname");
          var productId =  elem.data("productid");
          var productPrice = elem.data("productprice");
          var productBrand = elem.data("productbrand");
          var productType = elem.data("producttype");
          var productCollection = elem.data("productcollection");
          var variantInput = elem.data("variantinput");
          var shopCurrency =  elem.data("shopcurrency");

          window.dataLayer.push({
            event: 'ee_addToCart',
            name: productName,
            id: productId,
            price: productPrice,
            currency: shopCurrency,
            brand: productBrand,
            product_type: productType,
            category: productCollection,
            quantity: 1,
            variant: variantInput,
            g_product_id: "shopify_GB_"+productId+"_"+variantInput
          });
        });
      });
    }
  };

  config = {
    maxToShow: 8,
    minToShow: 1,
    howManyToStoreInMemory: 8,
    numberProducts: 0,
    gallerySection: '[data-gallery-recently-section]',
    galleryList: '[data-gallery-list]',
    onComplete: null
  };
  productHandleQueue = [];

  cookie = {
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(','));
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = localStorage.getItem(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',');
      }
      return recentlyViewed;
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      let position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  finalize = () => {
    // custom finalise
    let slider = document.querySelector('recently-viewed slider-component');
    let sliderButtons = document.querySelector('recently-viewed slider-component .slider-buttons');
    if (this.config.numberProducts < 5) {
      sliderButtons.classList.add('md:hidden');
    } else if (this.config.numberProducts < 3) {
      sliderButtons.classList.add('md-max:hidden');
    }
    slider.initPages()

  };

  getRecentProducts = async () => {
    let searchRecentlyUrl;
    let productHandle;

    if (window.location.pathname.indexOf('/products/') !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];
      this.productHandleQueue = this.productHandleQueue.filter(handle => productHandle !== handle);
    }

    if (this.productHandleQueue.length < this.config.minToShow) {
      document.querySelector('h2.recently').classList.add('hidden');
      document.querySelector('h2.recommended').classList.add('no-after');
      return;
    }
    this.config.numberProducts = this.productHandleQueue.length;

    this.productHandleQueue.length = this.config.maxToShow;
    searchRecentlyUrl =
      '/search?view=recently&q=' + this.productHandleQueue.toString();

    await fetch(searchRecentlyUrl).then(response =>
      response.text()
    ).then(html => {
      document.querySelector(this.config.galleryList).innerHTML = html
      this.atcEventTracking();
      this.finalize();
    }).catch(err => {
      console.warn('Something went wrong.', err);
    });

  };

  recordRecentlyViewed = values => {
    let vals = values || {};
    let recentlyViewed = this.cookie.read();
    let productHandle;
    let position;

    // Update defaults.
    this.config = {...this.config, ...vals};

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {

      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];

      position = recentlyViewed.indexOf(productHandle);

      if (position === -1) {

        recentlyViewed.unshift(productHandle);

        recentlyViewed = recentlyViewed.splice(
          0,
          this.config.howManyToStoreInMemory
        );
      } else {

        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      this.cookie.write(recentlyViewed);
    }
  }

  showRecentlyViewed = parameters => {
    let params = parameters || {};
    // Update defaults.
    this.config = {...this.config, ...params};

    // Read cookie.
    this.productHandleQueue = this.cookie.read();

    if (this.productHandleQueue === null || this.productHandleQueue === undefined) {
      return false;
    }

    this.config.maxToShow = Math.min(this.productHandleQueue.length, this.config.maxToShow);

    if (this.config.maxToShow) {
      this.getRecentProducts().then();
    } else {
      document.querySelector('h2.recently').classList.add('hidden');
      document.querySelector('h2.recommended').classList.add('no-after');
    }
  }

  connectedCallback() {
    this.showRecentlyViewed();
    this.recordRecentlyViewed();
  }
}

customElements.define('recently-viewed', RecentlyViewed);

